<!-- @format -->

<div class="login--{{ mobileMode ? 'mobile' : 'desktop' }}">
  <a
    class="login--{{ mobileMode ? 'mobile' : 'desktop' }}__item"
    [class.login--desktop__item--active]="isActive && !mobileMode"
    [uiSref]="loginState"
    [uiParams]="loginParams"
    [uiOptions]="loginOptions"
    [attr.aria-current]="isActive ? 'page' : null"
    (keydown)="keydownPressed.emit($event)"
    (keydown.escape)="blurMobileLogin.emit($event)"
    (blur)="blurMobileLogin.emit($event)">
    {{ "AUTH.LOGIN" | transloco }}
    @if (isActive && mobileMode) {
      <fudis-icon class="d-block float-end sisu-navigation__links__list__item--mobile__pointer" [icon]="'check'" [color]="'primary'" />
    }
  </a>
</div>
